import { FC } from 'react';

import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { MetricsConfigProps } from 'components/Metrics/config';

const Metrics: FC<MetricsConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { metrics, ...headingProps } = rest;

  return (
    <Section {...sectionProps}>
      <div className="flex flex-col items-center gap-12 sm:gap-16">
        <Heading {...headingProps} />
        <ScrollFadeSection delay={0.2}>
          <div className="grid grid-cols-1 gap-14 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3 lg:gap-14">
            {metrics?.map(metric => (
              <div key={metric.id} className="flex flex-col gap-3">
                <span className="line-clamp-1 font-spaceGrotesk text-display-3xl text-highlight-gradient lg:text-display-4xl">
                  {metric.value}
                </span>
                <p className="line-clamp-2 text-display-sm font-semibold text-gray-900 dark:text-white">
                  {metric.heading}
                </p>
                <div className="mt-3 line-clamp-6 text-lg text-body dark:text-gray-300">{metric.description}</div>
              </div>
            ))}
          </div>
        </ScrollFadeSection>
      </div>
    </Section>
  );
};

export default Metrics;
